export const usePathSegments = () => {
  const segments = window.location.pathname.split('/').filter(Boolean);
  return segments;
};
